<template>
  <div>
    <div v-if="show">
      <input
        type="text"
        class="uk-input"
        autocomplete="off"
        name="randominput-autocomplete-disable"
        id="randominput-autocomplete-disable"
        v-model="model"
      />
    </div>

    <div class="flex items-center  " v-else>
      <div class="uk-input ">**********</div>
      <div
        class="border-l bg-gray-200 hover:bg-gray-300 rounded-lg p-1 -ml-8"
        @click="showClick()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-4 cursor-pointer h-4"
          viewBox="0 0 512 512"
        >
          <path
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="32"
            d="M255.66 112c-77.94 0-157.89 45.11-220.83 135.33a16 16 0 0 0-.27 17.77C82.92 340.8 161.8 400 255.66 400c92.84 0 173.34-59.38 221.79-135.25a16.14 16.14 0 0 0 0-17.47C428.89 172.28 347.8 112 255.66 112"
          />
          <circle
            cx="256"
            cy="256"
            r="80"
            fill="none"
            stroke="currentColor"
            stroke-miterlimit="10"
            stroke-width="32"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../../services/http";
import EventBus from "../EventBus";

export default {
  name: "string",
  data() {
    return {
      model: null,
      show: false
    };
  },
  props: ["input", "form", "value", "rowall"],
  created() {
    if (this.value) {
      this.model = this.value;
    }
  },
  methods: {
    showClick() {
      this.show = !this.show;

      http
        .clickShowLog(this.input.table, this.input.name, this.form.id)
        .then(e => {});

      EventBus.$emit("clickShowLog", {
        id: this.form.id,
        key: this.input.name
      });
    }
  },
  watch: {
    form() {
      if (this.form) {
        this.model = null;
      }
    },
    model() {
      this.$parent.$emit("changed", {
        name: this.input.name,
        value: this.model
      });
    }
  }
};
</script>

<style></style>
